module.exports = __webpack_public_path__ + "static/img/cabinet24_9.b5500744.gif";